
export default [
  {
    "path": "legal/acceptable-use-policy",
    "policyVersion": "2026-09-21",
    "minAcceptanceVersion": "2026-09-21"
  },
  {
    "path": "legal/terms-of-use",
    "policyVersion": "2026-09-21",
    "minAcceptanceVersion": "2026-09-21"
  }
]